import { useSelector } from "react-redux";

const Map = ({ order }) => {
  const { shipping_address: fooAddress } = order;
  const addressMap =
    typeof fooAddress === "string" ? JSON.parse(fooAddress) : fooAddress;
  const address = [];
  for (const [key, value] of Object.entries(addressMap ?? {})) {
    if (["address1", "city", "province", "country"].includes(key) && value) {
      address.push(value);
    }
  }

  return (
    <div
      className="omg-map"
      dangerouslySetInnerHTML={{
        __html: `<iframe src="https://www.google.com/maps?q=${encodeURI(
          address.join(", ")
        )}&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100%" height="350"></iframe>`,
      }}
    ></div>
  );
};

export default Map;
